// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__Lkv_8","buttons":"Footer_buttons__3K3C4"};